import url from "url"
import env from "src/env"
import getCurrentUrl from "./getCurrentUrl"

const { REACT_APP_LOGOUT_PAGE_URL, REACT_APP_CLIENT_ID } = env

export default function redirectToLoginPage() {
  const currentUrl = getCurrentUrl()
  /* Before send current url, ensure it has no code param */
  /* Memoize current url */
  localStorage.setItem(`redirectUrl`, currentUrl)
  /* Redirect to login page */
  const redirectUrl = url.format({
    ...url.parse(REACT_APP_LOGOUT_PAGE_URL),
    query: {
      redirectUrl: currentUrl,
      clientId: REACT_APP_CLIENT_ID,
    },
  })
  document.location.href = redirectUrl
}
